import { connectedStore } from '../../store';
import selectors from '../selectors';

const getBuildSlug = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getBuildSlug(state);
};

export default getBuildSlug;
